import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eaa5a7b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "session-list-item__cell" }
const _hoisted_2 = { class: "session-list-item__cell" }
const _hoisted_3 = { class: "session-list-item__cell" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "session-list-item__end d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn p-0 rounded-0 border-0 kebab-button",
  "data-bs-toggle": "dropdown",
  "aria-label": "open session menu"
}, null, -1))
const _hoisted_8 = { class: "dropdown-menu p-0 rounded-0 border-0 shadow" }

import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'
import { useEventBus } from '@vueuse/core'
import { registerSessionKey, cancelSessionKey } from '@/config/events'
import { useSessionRegistryStore } from '@/components/SessionRegistryStore'
import CheckCircleBlue from '@/icons/CheckCircleBlue.vue'
import CoachingSessionInfoModal from '../CoachingSessionInfoModal/CoachingSessionInfoModal.vue'
import DocumentDownloadModal from '../DocumentDownloadModal/DocumentDownloadModal.vue'
import DocumentIcon from '@/icons/DocumentIcon.vue'
import { useClassroomStudentService } from '../ClassroomStudentService'
import { downloadFile } from '@/utils/downloadFile'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EbarSessionListItem',
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    isLastRow: { type: Boolean }
  },
  setup(__props: any) {

const props =
  __props

const registerSessionEventBus = useEventBus(registerSessionKey)
const cancelSessionEventBus = useEventBus(cancelSessionKey)
const { sessionActions } = useSessionRegistryStore()
const dayString = props.modelValue.localStartDateTime.toLocaleString('en-us',{weekday: 'long'}) + 's'
const showSessionInfo = ref(false)
const classroomStudentService = useClassroomStudentService()
const hasDocuments = props.modelValue.event.documentFileNames?.length > 0
const showDocumentDownloadModal = ref(false)
const documentsDownloading = ref([''])

function handleRegisterClick() {
  sessionActions.selectSession(props.modelValue)
  registerSessionEventBus.emit(props.modelValue.sessionId)
}

function handleCancelClick() {
  cancelSessionEventBus.emit()
}

function handleAddToCalendarClick() {
  classroomStudentService.downloadCalendarInvite(props.modelValue.event, props.modelValue.isLSAT)
}

function handleSessionInfoClick() {
  showSessionInfo.value = true
}

function handleDownloadDocuments() {
  if (props.modelValue.event.documentFileNames.length === 1) {
    downloadFiles([props.modelValue.event.documentFileNames[0]])
  } else {
    openDocumentDownloadModal()
  }
}

async function downloadFiles(fileNameList: string[]) {
  documentsDownloading.value = [ ...fileNameList ]
  try{
      await fileNameList.forEach(async (fileName) => {
        const file = await classroomStudentService.fetchEventDocument(props.modelValue.sessionId, fileName)
        if (file) {
          downloadFile(file, fileName)
          documentsDownloading.value = documentsDownloading.value.filter(f => f !== fileName)
        }
    })
  } catch (e) {
    documentsDownloading.value = []
    throw e
  }
}

function openDocumentDownloadModal() {
  showDocumentDownloadModal.value = true
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass({'session-list-item': true, showRegistered:_ctx.modelValue.showRegistered, 'grey-line': !props.isLastRow})
    }, [
      _createElementVNode("td", null, [
        (_ctx.modelValue.showRegistered)
          ? (_openBlock(), _createBlock(CheckCircleBlue, {
              key: 0,
              class: "checkmark-svg ms-3",
              role: "img",
              "aria-label": "currently enrolled session"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", { class: "session-list-item__cell" }, _toDisplayString(dayString)),
      _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.modelValue.localStartEndTime), 1),
      _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.modelValue.startEndDate), 1),
      _createElementVNode("td", _hoisted_3, [
        (!_ctx.modelValue.isFull)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Open Seats "))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, " Class Full "))
      ]),
      _createElementVNode("td", _hoisted_6, [
        hasDocuments
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn ms-auto rounded-0",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleDownloadDocuments()))
            }, [
              _createVNode(DocumentIcon)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(['dropstart me-3 ', hasDocuments ? 'ms-3' : 'ms-auto'])
        }, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_ctx.modelValue.showRegistered)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "dropdown-item p-3 px-4 lh-base border-bottom",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleCancelClick()))
                }, " Cancel/Reschedule Session "))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "dropdown-item p-3 px-4 lh-base border-bottom",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleRegisterClick()))
                }, " Register for Session ")),
            (_ctx.modelValue.showRegistered)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "dropdown-item p-3 px-4 lh-base border-bottom",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (handleAddToCalendarClick()))
                }, " Add to Calendar "))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: _normalizeClass(['dropdown-item p-3 px-4 lh-base', { 'border-bottom': hasDocuments }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (handleSessionInfoClick()))
            }, " Session Info ", 2),
            hasDocuments
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "dropdown-item p-3 px-4 lh-base",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (handleDownloadDocuments()))
                }, " Download Documents "))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ])
    ], 2),
    _createVNode(CoachingSessionInfoModal, {
      visible: showSessionInfo.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((showSessionInfo).value = $event)),
      "coaching-session": _ctx.modelValue
    }, null, 8, ["visible", "coaching-session"]),
    _createVNode(DocumentDownloadModal, {
      visible: showDocumentDownloadModal.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((showDocumentDownloadModal).value = $event)),
      "file-names": _ctx.modelValue.event.documentFileNames ?? [],
      "documents-downloading": documentsDownloading.value,
      onDownloadFiles: downloadFiles
    }, null, 8, ["visible", "file-names", "documents-downloading"])
  ], 64))
}
}

})